<template>
  <div class="active-container">
    <div class="active-header">
    <div class="logo" />
    </div>
    <div class="login-content">
      <div class="bgc top"></div>
      <div class="bgc right"></div>
      <div class="bgc left"></div>
      <div class="bgc bottom"></div>
      <div class="login-form">
        <h2 class="login-title">激活码申请</h2>
        <div class="upload_file">
          <div class="license">
            <label for=""
              ><i class="icon-file"></i><span>License文件</span>
            </label>
            <Input
              class="ellips"
              v-model="fileName"
              placeholder="请选择License文件"
              id="file"
              readonly
              disabled
            />
          </div>
          <Upload
            accept=".lic"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
          >
            <a>选择文件</a>
          </Upload>
        </div>
        <div class="license">
          <label for=""><i class="icon-ID"></i><span>虚拟ID</span> </label>
          <Input v-model="fileId" :maxLength="50" placeholder="请输入虚拟ID"/>
          <!-- <Input v-model.trim="fileId" :maxLength="50" placeholder="请输入虚拟ID" @keyup="toTrim"/> -->
        </div>
        <div class="code">
          <div class="tips" v-show="!ErrorTipFlag"></div>
          <div class="tips" v-show="ErrorTipFlag">
            <div v-show="!codeIconType" class="text_icon">
              <p class="left_icon"><img src="@/assets/img/message.svg" alt="" />
              </p>
              <p class="right_text">{{ tipsText }}</p>
            </div>
            <div v-show="codeIconType" :class="{ success: codeIconType }">
              <p class="left_active_code"><span v-show="isActiveFlag" >激活码已生成：</span>{{ activeCode }}</p>
              <p class="right_copy">
                <a v-clipboard:copy="activeCode" v-clipboard:success="onSuccess">复制</a>
              </p>
            </div>
          </div>
        </div>
        <Button class="login-button" type="primary" @click="handleSubmit">
          申请激活码
        </Button>
      </div>
    </div>
    <div class="login-footer">
      Copyright ©2007-2021 All rights reserved. 北京博睿宏远数据科技股份有限公司
      版权所有 京 ICP备 08104257 号 京公网安备 11010102002419
    </div>
    <Modal
      dialogClass = 'active_code'
      title="提示信息"
      width='400px'
      centered
      :visible="visible"
      @ok="getCode"
      @cancel="handleCancel"
    >
      <p class="confirm_img_text">
        <img style="margin-top:-2px" src="@/assets/img/message.svg" alt=""/><span style="margin-left:8px">确认申请激活码</span>
      </p>
      <p class="error">注：该激活码每个license只能生成一次！</p>
    </Modal>
  </div>
</template>

<script>
import Vue from 'vue'
import './active.less'
import { Layout, Button, Input, Upload,Modal } from 'ant-design-vue'
const { Header, Footer } = Layout
import { encodePwd } from '@/util/utils.js'
import VueClipboard from 'vue-clipboard2'
import axiosCommon from '@/api/axiosCommon';
Vue.use(VueClipboard)
export default {
  data() {
    return {
      codeValidFlag: false, // 默认不展示图标
      ErrorTipFlag: false,
      tipsText: '',
      codeIconType: false,
      isDisable: 0,
      accept: 'lic',
      fileName: '',
      fileContent:'',
      fileId: '',
      activeCode: '',
      fileContent: '',
      visible:false,
      isActiveFlag:false
    }
  },
  created() {
    // 获取验证码
  },
  computed:{

  },
  methods: {
    beforeUpload(file) {
      this.fileName = file.name.replace(/\s*/g,"")
      file.size < 1024 * 1024 * 50
      const reader = new FileReader()
      reader.readAsText(file)
      reader.onerror = (e) => {
      }
      reader.onload = (e) => {
        let a = '=============================== BRLICENSE =================================='
        this.fileContent = e.target.result.split(a)[1]
      }
      return false
    },
    // toTrim(){
    //   this.fileId = this.fileId.replace(/[, ]/g,'')
    // },
    // 提交
    handleSubmit() {
      this.isDisable++
      if (this.isDisable != 1) return
      setTimeout(() => {
        this.isDisable = 0 //点击一次时隔两秒后才能再次点击
      }, 2000)
      // this.codeValidFlag = true
      this.codeIconType = false
      this.activeCode = ''
      this.tipsText = ''
      this.ErrorTipFlag = false
      if (this.fileName.trim() === '' || this.fileId.trim() === '') {
        this.codeIconType = false
        this.ErrorTipFlag = true
        this.tipsText = '不能为空'
        return
      }
      this.visible = true
    },
    async getCode(){
      this.visible = false;
      let params = {
        content:this.fileContent,
        virtualId: this.fileId.replace(/\s*/g,"")
      }
      let result = await axiosCommon.post('/rest/generateCode',params)
        if (result?.msg && result?.msg !== 'success' ) {
          this.codeIconType = false
          this.ErrorTipFlag = true
          this.tipsText = result.msg
          // this.activeCode = ''
        } else if (result) {
          this.codeIconType = true
          this.ErrorTipFlag = true
          // this.tipsText = '激活码已生成：'
          this.isActiveFlag=true
          this.activeCode = result
        }
    },
    handleCancel(e) {
      this.visible = false;
    },
    onSuccess() {
      this.$message.success('复制成功', 1)
    },
  },
  components: {
    Header,
    Footer,
    Button,
    Input,
    Upload,
    Modal
  }
}
</script>
